import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import Api from '../../Services/Api';
import Alert from '../../Services/Alert';
import { defaultPermissions } from './permissionModules';
import PermissionMatrix from './PermissionMatrix';

export const SubAdminAdd = () => {
    const history = useHistory();
    const [form, setForm] = useState({ firstname: '', lastname: '', email: '', password: '', confirm: '' });
    const [permissions, setPermissions] = useState(defaultPermissions(false));
    const [saving, setSaving] = useState(false);

    const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

    function validate() {
        if (!form.firstname.trim() || !form.lastname.trim()) return 'First and last name are required';
        if (!/\S+@\S+\.\S+/.test(form.email)) return 'A valid email is required';
        if (form.password.length < 6) return 'Password must be at least 6 characters';
        if (form.password !== form.confirm) return 'Passwords do not match';
        return null;
    }
    function submit(e) {
        e.preventDefault();
        const err = validate();
        if (err) return Alert.error(err);
        setSaving(true);
        Api.post('roles/sub-admins/create', {
            firstname: form.firstname, lastname: form.lastname, email: form.email, password: form.password, permissions
        }).then((r) => r.data).then((res) => {
            setSaving(false);
            if (res.status == 1) { Alert.success(res.message); history.push('/roles/sub-admins'); }
            else { Alert.error(res.message); }
        }).catch(() => setSaving(false));
    }

    return (
        <section className="main-content">
            <div className="page-content"><div className="container-fluid">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0">Add Sub-Admin</h4>
                    <button className="btn btn-outline-secondary btn-sm" onClick={() => history.push('/roles/sub-admins')}>Back to list</button>
                </div>
                <form onSubmit={submit}>
                    <div className="row">
                        <div className="col-lg-5">
                            <div className="card"><div className="card-body">
                                <h5 className="card-title mb-3">Account Details</h5>
                                <div className="form-group mb-3"><label>First Name</label><input className="form-control" name="firstname" value={form.firstname} onChange={onChange} /></div>
                                <div className="form-group mb-3"><label>Last Name</label><input className="form-control" name="lastname" value={form.lastname} onChange={onChange} /></div>
                                <div className="form-group mb-3"><label>Email</label><input className="form-control" type="email" name="email" value={form.email} onChange={onChange} /></div>
                                <div className="form-group mb-3"><label>Password</label><input className="form-control" type="password" name="password" value={form.password} onChange={onChange} /></div>
                                <div className="form-group mb-3"><label>Confirm Password</label><input className="form-control" type="password" name="confirm" value={form.confirm} onChange={onChange} /></div>
                                <button className="btn btn-primary" type="submit" disabled={saving}>{saving ? 'Saving…' : 'Create Sub-Admin'}</button>
                            </div></div>
                        </div>
                        <div className="col-lg-7">
                            <div className="card"><div className="card-body">
                                <PermissionMatrix permissions={permissions} setPermissions={setPermissions} />
                            </div></div>
                        </div>
                    </div>
                </form>
            </div></div>
        </section>
    );
};
export default SubAdminAdd;
